import { __exports as o } from "../../../../_virtual/toArray.mjs";
import "../../../@babel/runtime/helpers/interopRequireDefault.mjs";
import u from "react";
import "../../../react-is/index.mjs";
import { exports as p } from "../../../../_virtual/interopRequireDefault.mjs";
import { exports as s } from "../../../../_virtual/index2.mjs";
var f = p.default;
Object.defineProperty(o, "__esModule", {
  value: !0
});
var y = o.default = t, i = f(u), m = s;
function t(n) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e = [];
  return i.default.Children.forEach(n, function(r) {
    r == null && !a.keepEmpty || (Array.isArray(r) ? e = e.concat(t(r)) : (0, m.isFragment)(r) && r.props ? e = e.concat(t(r.props.children, a)) : e.push(r));
  }), e;
}
export {
  y as default
};
//# sourceMappingURL=toArray.mjs.map
